export const APP_HISTORY_INDEX_KEY = '__menuLabHistoryIndex';
export const APP_HISTORY_SCROLL_Y_KEY = '__menuLabScrollY';

type HistoryStateRecord = Record<string, unknown>;

function stateRecord(state: unknown): HistoryStateRecord {
  return state && typeof state === 'object' && !Array.isArray(state) ? state as HistoryStateRecord : {};
}

export function readAppHistoryIndex(state: unknown): number | null {
  const value = stateRecord(state)[APP_HISTORY_INDEX_KEY];
  return typeof value === 'number' && Number.isInteger(value) ? value : null;
}

export function readAppHistoryScrollY(state: unknown): number | null {
  const value = stateRecord(state)[APP_HISTORY_SCROLL_Y_KEY];
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function appHistoryState(state: unknown, index: number, scrollY?: number): HistoryStateRecord {
  return {
    ...stateRecord(state),
    [APP_HISTORY_INDEX_KEY]: index,
    ...(scrollY === undefined ? {} : { [APP_HISTORY_SCROLL_Y_KEY]: Math.max(0, scrollY) })
  };
}

export function appHistoryScrollState(state: unknown, scrollY: number): HistoryStateRecord {
  return { ...stateRecord(state), [APP_HISTORY_SCROLL_Y_KEY]: Math.max(0, scrollY) };
}

export function nextAppHistoryIndex(current: number): number {
  return current + 1;
}

export function restorationDelta(current: number, target: number | null): number | null {
  if (target === null) return null;
  return current - target;
}
